<app-header [label]="page_name | plural"></app-header>
<app-ag-grid-list [delete_permission]="gs.user_role_data?.evaluation_management_academic_year_delete" [list]="items" [colDefs]="columns" [itemName]="page_name" (fetch_new_list)="get_list($event)" (bulkDelete)="bulk_delete($event)">
  <div toolbar class="flex bg-white gap-4 items-center justify-end p-4 border-b border-gray-200">
    <app-search-input #searchbar (fetch_new_list)="get_list($event)"></app-search-input>
    <app-button color="bg-white border-primary text-primary" icon="bx bx-download" (click)="download()"></app-button>
    <app-dropdown-upload-button *ngIf="gs.user_role_data?.evaluation_management_academic_year_add" [page_name]="page_name" (bulkUpload)="bulk_modal.open()" (singleUpload)="open_form_modal()"></app-dropdown-upload-button>
  </div>
</app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to Delete Academic Year.
</app-confirmation-popup>
<app-confirmation-popup #confirmation_disabled_modal [enable_icon]="selected_ids.is_active == true ? false : true" [disabled_icon]="selected_ids.is_active == false ? false : true" confirmColor="bg-[#FA2912] text-[#FFFFFF]" [is_mandatory]="true" (confirm_modal_clicked)="update_country(selected_ids.is_active)" (close_modal_clicked)="confirmation_delete_modal.close()">
  Are you sure you want to {{selected_ids.is_active == true? "Disable" :"Enable"}} Academic Year
</app-confirmation-popup>
<app-modal #form_modal [label]="`${selected_ids.id ? 'Update' : 'Add'} ${page_name}`">
  <form [formGroup]="form">
    <div class="py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <div>
        <app-text-input [is_required]="true" [type_total_latter]="9" class="w-full" [label]="page_name" placeholder="YYYY-YYYY" formControlName="name"></app-text-input>
        <div *ngIf="form.get('name')?.errors?.['invalidYearDifference']" class="text-red-500 text-sm mt-1">
          Academic year must have exactly 1 year difference (e.g., 2026-2027)
        </div>
      </div>
      <div>
        <app-date-input [is_required]="true" label="Start Date" #start_date [minDateInput]="minStartDate" [maxDateInput]="maxStartDate" [defaultDateInput]="defaultStartDate" formControlName="start_date"></app-date-input>
        <div *ngIf="form.get('start_date')?.errors?.['overlappingAcademicYear']" class="text-red-500 text-sm mt-1">
          Start Date cannot overlap with existing academic year ranges.
        </div>
        <div *ngIf="form.get('start_date')?.errors?.['startDateNotInRange']" class="text-red-500 text-sm mt-1">
          Start Date must be in the first year of academic year ({{form.get('name')?.value?.split('-')[0]}})
        </div>
      </div>
      <div>
        <app-date-input [is_required]="true" label="End Date" #end_date [minDateInput]="start_date.value" [maxDateInput]="maxEndDate" formControlName="end_date"></app-date-input>
      </div>
    </div>
    <div class="flex justify-end items-center gap-2">
      <app-button color="border-primary text-primary" label="Cancel" type="button" (click)="close_form_modal()"></app-button>
      <app-button color="bg-secondary text-black" [label]="params.id ? 'update' :'Add'" type="button" [disabled]="isSubmitting" [submit]="submit.bind(this)"></app-button>
    </div>
  </form>
</app-modal>

<app-modal #bulk_modal label="Bulk Upload {{page_name | plural}}" sub_label="Add {{ page_name }} in Bulk">
  <app-bulk-upload [cancel]="bulk_modal" [accepted_type]="['.csv']" [title]="page_name" [max_file_sizeMB]="5" [bulk_columns]="bulk_columns" [row_validator]="validate_academic_year_row" (submit)="bulk_upload($event.data,$event.spinner)"></app-bulk-upload>
</app-modal>

<app-modal #view_modal [label]="'View '+ page_name" width="md" (close_modal_clicked)="view_modal.close()">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">{{page_name}}</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.name || '—' }}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">Start Date</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.start_date | date:'dd-MM-yyyy'}}</p>
    </div>
    <div class="p-2 break-words">
      <p class="font-semibold text-gray-700">End Date</p>
      <p class="text-gray-900 mt-1">{{ selected_ids?.end_date | date:'dd-MM-yyyy' }}</p>
    </div>
  </div>
</app-modal>